var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "station-edit-dialog",
      attrs: {
        "append-to-body": "",
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "serialNumber",
                          max: 999999,
                          min: 1,
                          "controls-position": "right"
                        },
                        model: {
                          value: _vm.form.serialNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "serialNumber", $$v)
                          },
                          expression: "form.serialNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.city.code"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "code",
                          disabled: !_vm.isAddedFromTemplate
                        },
                        model: {
                          value: _vm.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("baseInfo.city.chineseName") } },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: { no: "chineseName" },
                        model: {
                          value: _vm.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chineseName", $$v)
                          },
                          expression: "form.chineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.city.englishName"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: { no: "englishName" },
                        model: {
                          value: _vm.form.englishName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "englishName", $$v)
                          },
                          expression: "form.englishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ExchangeCode") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "interchangeCode",
                          disabled: !_vm.isAddedFromTemplate
                        },
                        model: {
                          value: _vm.form.interchangeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "interchangeCode", $$v)
                          },
                          expression: "form.interchangeCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_IsoCode") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "isoCode",
                          disabled: !_vm.isAddedFromTemplate
                        },
                        model: {
                          value: _vm.form.isoCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "isoCode", $$v)
                          },
                          expression: "form.isoCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_CountryRegion") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "countryCode",
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          cache: false,
                          filterable: "",
                          "callback-params": { key: "countryCode" },
                          "callback-method-type": "value",
                          "default-value": _vm.form.countryCode,
                          "static-options": _vm.countryList
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Region") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "region",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "show-custom-label-in-option": true,
                          "callback-params": { key: "region" },
                          "callback-method-type": "value",
                          "default-value": _vm.form.region
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CityName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "5px" },
                        attrs: { no: "cityName", disabled: "" },
                        model: {
                          value: _vm.form.cityName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cityName", $$v)
                          },
                          expression: "form.cityName"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "cityClickHandler", type: "primary" },
                          on: { click: _vm.cityClickHandler }
                        },
                        [_vm._v("...")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { no: "save", type: "primary" }, on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c("location-search-dialog", {
        attrs: { visible: _vm.cityDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.cityDialogVisible = $event
          },
          addCallBack: _vm.selectLocalHandler,
          close: function($event) {
            _vm.cityDialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }